export const MESSAGES_ERROR_TITLE = "Couldn't load messages";

export const MESSAGES_ERROR_SUBTITLE = 'Something went wrong fetching this step’s messages.';

export const MESSAGES_RETRY_LABEL = 'Retry';

export const MESSAGES_SKELETON_ROW_COUNT = 3;

export const MESSAGES_SKELETON_ROW_HEIGHT = 48;
